// InfoWindow Styles
.gm-style {
  .gm-style-iw {
    font-weight: 400;
    font-size: 0.875rem;
    font-family: UvexNHG, Arial, Geneva, Helvetica, sans-serif;
  }

  .gm-style-iw-c {
    padding: 0 !important;
    border-radius: 0;
    box-shadow: none;
    overflow: visible;

    .gm-style-iw-chr {
      position: absolute;
      z-index: 1;
      right: -6px;
      top: -6px;
    }

    .gm-style-iw-d {
      overflow: hidden !important;

      uvex-dealerlocator-location .specialization {
        padding-right: 1.5rem;
      }
    }

    // Close Button
    > button {
      display: inline-block;
      background: transparent no-repeat url('/_assets/5717309059aa7d6776af66ec5afaeb95/Images/Map/Close.svg') -5px 8px !important;

      &.gm-ui-hover-effect {
        opacity: 1;
      }

      img,
      span {
        display: none !important;
      }
    }

    &:before,
    &:after {
      border-left: 25px solid transparent;
      border-right: 25px solid transparent;
      content: '';
      bottom: -22px;
      position: absolute;
      left: calc(50% - -30px);
      border-top: 25px solid #fff;
    }

    &:before {
      bottom: -24px;
      border-top: 25px solid #c9c7c7;
    }
  }

  .gm-style-iw-tc::after,
  .gm-style-iw-t::after {
    display: none;
  }
}
